import React from 'react';

const EmpathySection = () => {
  return (
    <div id="empathy-section" className="empathy-section">
      <div className="container mx-auto">
        <div className="w-full lg:w-1/3 lg:mx-auto">
          <div className="section-heading wow fadeIn" data-wow-duration="1s" data-wow-delay="0.3s">
            <h6>Created by Pastors - for Pastors</h6>
            <h4>Managing a ministry is hard. Let us help.</h4>
            <div className="line-dec my-4 mx-auto w-24 h-1 bg-gray-300"></div>
          </div>
        </div>
        <div className="w-full lg:w-2/3 lg:mx-auto wow fadeIn" data-wow-duration="1s" data-wow-delay="0.8s">
          <div className="flex justify-center">
            <iframe
              width="640"
              height="417"
              src="https://www.loom.com/embed/9991bc3c9ccb487f896696f6e8ab32d3?sid=4ab475d8-d1ac-4f4d-9076-db7940d1e450"
              frameBorder="0"
              webkitAllowFullScreen
              mozAllowFullScreen
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmpathySection;